import { Component, inject, Input } from '@angular/core';
import { MessageTelegram } from "../../../../types/last-message.types";
import { GetFileParams } from "../../../../types/telegram-page.types";
import { TelegramApiService } from "../../../../services/telegram-api.service";
import { UploadProgressService } from "../../../../../../../core/services/upload-progress.service";
import { HttpEventType } from "@angular/common/http";
import { ErrorService } from "../../../../../../../core/services/error.service";
import { TelegramAccountsService } from "../../../../services/telegram-accounts.service";
import { FilesService } from "../../../../../../../core/services/files.service";
import { ProgressStatus } from "../../../../../../../core/types/upload-progress.types";
import { MatFabButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";
import { TelegramUploadStatusComponent } from "../telegram-upload-status/telegram-upload-status.component";
import { FileSizePipe } from "../../../../../../../shared/pipes/file-size.pipe";

@Component({
  selector: 'app-telegram-message-document',
  standalone: true,
  imports: [
    MatFabButton,
    MatIcon,
    TelegramUploadStatusComponent,
    FileSizePipe
  ],
  templateUrl: './telegram-message-document.component.html',
  styleUrl: './telegram-message-document.component.scss'
})
export class TelegramMessageDocumentComponent {
  @Input({ required: true }) message!: MessageTelegram;

  public uploadProgressService: UploadProgressService = inject(UploadProgressService);
  private telegramApiService: TelegramApiService = inject(TelegramApiService);
  private errorService: ErrorService = inject(ErrorService);
  private telegramAccountsService: TelegramAccountsService = inject(TelegramAccountsService);
  private filesService: FilesService = inject(FilesService);

  public currentMessageId: number = 0;

  public async downloadDocument(): Promise<void> {
    this.currentMessageId = this.message.id;
    await this.getDocument({
      remoteId: this.message.documentRemoteId,
      accountId: this.telegramAccountsService.selectedAccount().accountId
    });
    this.currentMessageId = 0;
  }

  private async getDocument(getFileParams: GetFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.telegramApiService.getDocument(getFileParams).subscribe({
        next: (event) => {
          const progress = this.handleUploadEvent(event);
          this.uploadProgressService.updateProgress({
            progress: progress.progress,
            completed: progress.completed,
            fileName: this.message.content.document?.fileName || '',
            fileType: 'file',
          });
        },
        error: (error) => {
          this.errorService.handleError(error);
          this.uploadProgressService.resetProgress();
          reject(error);
        },
        complete: () => {
          setTimeout(() => {
            this.uploadProgressService.resetProgress();
            resolve();
          }, 300);
        },
      });
    });
  }

  private handleUploadEvent(event: any): ProgressStatus {
    switch (event.type) {
      case HttpEventType.DownloadProgress:
        const progress = Math.round(100 * event.loaded / (this.message.content.document?.document.size || 1));
        return { progress, completed: false };
      case HttpEventType.Response:
        this.initiateFileDownload(event.body as Blob, this.message.content.document?.fileName || '');
        return { progress: 100, completed: true };
      default:
        return { progress: 0, completed: false };
    }
  }

  private initiateFileDownload(file: Blob, fileName: string): void {
    const fileDownloadOptions = {
      file: file,
      fileName: fileName
    };

    this.filesService.initiateFileDownload(fileDownloadOptions);
  }
}
